import React, { useState } from "react";
import axios from "axios";
import heic2any from "heic2any";
import "./AddYad2TaxiForSaleForm.css";

const AddYad2TaxiForSaleForm = () => {
  const [manufacturer, setManufacturer] = useState("");
  const [model, setModel] = useState("");
  const [year, setYear] = useState("");
  const [price, setPrice] = useState("");
  const [km, setKm] = useState("");
  const [description, setDescription] = useState("");
  const [phone, setPhone] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [region, setRegion] = useState("");
  const [ownership, setOwnership] = useState("");
  const [hand, setHand] = useState("");
  const [test, setTest] = useState("");
  const [dateOnRoad, setDateOnRoad] = useState("");
  const [publishDate, setPublishDate] = useState(""); // תאריך פרסום
  const [images, setImages] = useState([]);
  
const manufacturers = [
  "מרצדס",
  "סקודה",
  "טויוטה",
  "יונדאי",
  "קיה",
  "שברולט",
  "פולקסווגן",
  "פורד",
  "פיג'ו",
  "רנו",
  "ניסאן",
  "מיצובישי",
  "אופל",
  "דאצ'יה",
  "סיאט",
  "הונדה",
  "סיטרואן",
  "MG",
  "ג'ילי",
  "טסלה",
  "סאניאנג"
];


  const sendErrorToBackend = async (error, location) => {
    try {
      await axios.post("/api/logErrors", {
        message: error.message || "Unknown error",
        source: location,
        error: error.stack || "No stack trace",
      });
    } catch (err) {
      console.error("❌ שגיאה בשליחת לוג שגיאות לשרת:", err);
    }
  };
  

  const handleImageUpload = async (e) => {
    const files = [...e.target.files];
    const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/heic", "image/heif"];
    const validFiles = [];

    for (let file of files) {
      if (!validTypes.includes(file.type)) {
        alert("❌ יש לבחור קובץ תמונה בלבד (JPEG, PNG, GIF, HEIC)");
        continue;
      }

      if (file.size > 5 * 1024 * 1024) {
        alert("❌ התמונה גדולה מדי, יש לבחור תמונה בגודל קטן יותר מ-5MB");
        continue;
      }

      if (file.type === "image/heic" || file.type === "image/heif") {
        try {
          const convertedBlob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.8,
          });
          
          const convertedFile = new File([convertedBlob], file.name.replace(".heic", ".jpg"), {
            type: "image/jpeg",
          });

          validFiles.push(convertedFile);
        } catch (err) {
          console.error("❌ שגיאה בהמרת קובץ HEIC ל-JPEG:", err);
          await sendErrorToBackend(err, "handleImageUpload");
        }
      } else {
        validFiles.push(file);
      }
    }

    setImages(prevImages => [...prevImages, ...validFiles]);
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("manufacturer", manufacturer);
    formData.append("model", model);
    formData.append("year", year);
    formData.append("price", price);
    formData.append("km", km);
    formData.append("description", description);
    formData.append("phone", phone);
    formData.append("whatsapp", whatsapp);
    formData.append("region", region);
    formData.append("ownership", ownership);
    formData.append("hand", hand);
    formData.append("test", test);
    formData.append("dateOnRoad", dateOnRoad);
    formData.append("publishDate", publishDate);

    images.forEach((image, index) => {
      formData.append("images", image);
    });

    // ✅ בדוק מה נשלח באמת לפני השליחה
    console.log("📦 נתונים שנשלחים:", formData);
    for (let pair of formData.entries()) {
        console.log(`${pair[0]}:`, pair[1]);
    }

    try {
const res = await axios.post("/api/taxiforsale/add", formData, {
  headers: { "Content-Type": "multipart/form-data" },
});

if (res.data.success) {
  alert("✅ המונית נוספה בהצלחה!");
} else {
  alert("❌ קרתה שגיאה כלשהי בצד השרת");
}

      alert("✅ המונית נוספה בהצלחה!");
    } catch (err) {
      console.error("❌ שגיאה בשליחה:", err);
      alert(`❌ שגיאה בשליחה: ${err.message}`);
      await sendErrorToBackend(err, "handleSubmit");
    }
  };


  return (
    <div className="add-taxi-form">
      <h2>הוספת מונית למכירה</h2>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <label className="add-taxi-label">יצרן:</label>
        <select className="add-taxi-select" value={manufacturer} onChange={(e) => setManufacturer(e.target.value)} required>
          <option value="">בחר יצרן</option>
          {manufacturers.map((manu, index) => (
            <option key={index} value={manu}>{manu}</option>
          ))}
        </select>

        <label className="add-taxi-label">דגם:</label>
        <input className="add-taxi-input" type="text" value={model} onChange={(e) => setModel(e.target.value)} required />

        <label className="add-taxi-label">שנתון:</label>
        <input className="add-taxi-input" type="number" value={year} onChange={(e) => setYear(e.target.value)} required />

        <label className="add-taxi-label">מחיר (לא כולל מע\"מ):</label>
        <input className="add-taxi-input" type="number" value={price} onChange={(e) => setPrice(e.target.value)} required />

        <label className="add-taxi-label">ק\"מ:</label>
        <input className="add-taxi-input" type="number" value={km} onChange={(e) => setKm(e.target.value)} required />

        <label className="add-taxi-label">תיאור:</label>
        <textarea className="add-taxi-textarea" value={description} onChange={(e) => setDescription(e.target.value)} />

        <label className="add-taxi-label">טלפון:</label>
        <input className="add-taxi-input" type="text" value={phone} onChange={(e) => setPhone(e.target.value)} />

        <label className="add-taxi-label">קישור וואטסאפ:</label>
        <input className="add-taxi-input" type="text" value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)} />

        <label className="add-taxi-label">אזור מגורים:</label>
        <input className="add-taxi-input" type="text" value={region} onChange={(e) => setRegion(e.target.value)} />

        <label className="add-taxi-label">בעלות:</label>
        <select className="add-taxi-select" value={ownership} onChange={(e) => setOwnership(e.target.value)} required>
          <option value="">בחר בעלות</option>
          <option value="מגרש">מגרש</option>
          <option value="פרטית (נהג מונית)">פרטית (נהג מונית)</option>
        </select>

        <label className="add-taxi-label">יד:</label>
        <input className="add-taxi-input" type="text" value={hand} onChange={(e) => setHand(e.target.value)} />

        <label className="add-taxi-label">טסט:</label>
        <input className="add-taxi-input" type="text" value={test} onChange={(e) => setTest(e.target.value)} />

        <label className="add-taxi-label">תאריך עלייה לכביש:</label>
        <input className="add-taxi-input" type="date" value={dateOnRoad} onChange={(e) => setDateOnRoad(e.target.value)} />

        <label className="add-taxi-label">תאריך פרסום באתר:</label>
        <input className="add-taxi-input" type="date" value={publishDate} onChange={(e) => setPublishDate(e.target.value)} />

        <label className="add-taxi-label">תמונות:</label>
        <input className="add-taxi-file" type="file" multiple onChange={handleImageUpload} accept="image/*" />

        <button className="add-taxi-button" type="submit">הוסף מונית</button>
      </form>
    </div>
  );
};

export default AddYad2TaxiForSaleForm;
